import { defineNuxtPlugin } from 'nuxt/app';

declare global {
  interface Window {
    dataLayer: [Object];
  }
}

export default defineNuxtPlugin(() => {
})
